"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Pill_1 = require("./Pill");
exports.Pill = Pill_1.Pill;
var PillBox_1 = require("./PillBox");
exports.PillBox = PillBox_1.PillBox;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@abb/common-ux/dist/components/Pill/index.js
// module id = 592
// module chunks = 1